import type { HTMLAttributes, ReactNode } from 'react';

export interface StepProps extends HTMLAttributes<HTMLDivElement> {
  name: string;
  label: string;
  adornment?: ReactNode;
  disabled?: boolean;
}

export default function Step({
  name,
  label,
  adornment,
  disabled,
  ...props
}: StepProps) {
  return <div {...props} />;
}
